import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to fetch all pod types
export const fetchPodTypes = createAsyncThunk(
  'podType/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get('http://localhost:3000/api/podtypes');
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Failed to fetch pod types');
    }
  }
);

const podTypeSlice = createSlice({
  name: 'podType',
  initialState: {
    podTypes: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPodTypes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPodTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.podTypes = action.payload;
      })
      .addCase(fetchPodTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Error fetching pod types';
      });
  },
});

export default podTypeSlice.reducer;